import { useId, type JSX, type ReactNode } from 'react';

import { hintClass, labelClass } from './styles.ts';

export interface FieldProps {
  readonly label: string;
  /** A sentence under the control, for what the label cannot say in three words. */
  readonly hint?: string;
  /** The control, given the id its label points at. */
  readonly children: (id: string) => ReactNode;
}

/** A labelled control: one id, generated once, never spelled out by a caller. */
export function Field({ label, hint, children }: FieldProps): JSX.Element {
  const id = useId();

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className={labelClass}>
        {label}
      </label>
      {children(id)}
      {hint === undefined ? null : <p className={hintClass}>{hint}</p>}
    </div>
  );
}
